module.exports = __webpack_public_path__ + "img/AF_GusmãoLabrunie_Icones_patents-.e30ffcd1.png";